import React from 'react';

const LogoutIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.695 8.705C14.3053 9.09472 14.3043 9.72627 14.6928 10.1172L15.57 11H10.8C10.2477 11 9.8 11.4477 9.8 12C9.8 12.5523 10.2477 13 10.8 13H15.57L14.6975 13.8725C14.3064 14.2636 14.3052 14.8975 14.695 15.29C15.083 15.6807 15.7143 15.683 16.105 15.295C16.1058 15.2942 16.1067 15.2933 16.1075 15.2925L19.4 12L16.105 8.705C15.7156 8.31564 15.0844 8.31564 14.695 8.705ZM7 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H7C5.9 3 5 3.9 5 5V19C5 20.1 5.9 21 7 21H13C13.5523 21 14 20.5523 14 20C14 19.4477 13.5523 19 13 19H7V5Z"
      fill="#666666"
    />
  </svg>
);

export default LogoutIcon;
